import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useRanking } from '@/hooks/useFriends'
import type { RankingPeriod, RankingRow } from '@/api/friends'
import FriendRow from './FriendRow'

const PAGE_SIZE = 10

const PERIODS: { value: RankingPeriod; label: string }[] = [
  { value: 'weekly', label: '週間' },
  { value: 'monthly', label: '月間' },
  { value: 'yearly', label: '年間' },
  { value: 'total', label: '累計' },
]

export default function RankingTab() {
  const navigate = useNavigate()
  const [period, setPeriod] = useState<RankingPeriod>('weekly')
  const [offset, setOffset] = useState(0)
  const { data, isLoading } = useRanking(period, offset, PAGE_SIZE)

  const changePeriod = (p: RankingPeriod) => {
    setPeriod(p)
    setOffset(0)
  }

  const rows = data?.results ?? []
  const total = data?.count ?? 0
  const hasMore = offset + PAGE_SIZE < total
  const meId = data?.me?.user.id ?? null

  return (
    <div className="flex flex-col">
      {/* 期間セグメント */}
      <div className="flex py-2">
        {PERIODS.map((p) => (
          <button
            key={p.value}
            onClick={() => changePeriod(p.value)}
            className={cn(
              'flex-1 border-b-2 py-1.5 text-sm transition-colors',
              period === p.value
                ? 'border-primary font-medium text-primary'
                : 'border-transparent text-muted-foreground',
            )}
          >
            {p.label}
          </button>
        ))}
      </div>

      {isLoading ? (
        <p className="py-10 text-center text-sm text-muted-foreground">読み込み中…</p>
      ) : rows.length === 0 ? (
        <p className="py-10 text-center text-sm text-muted-foreground">
          ランキングに表示できるフレンドがいません。
        </p>
      ) : (
        <div className="divide-y">
          {rows.map((row) => (
            <RankingItem
              key={row.user.id}
              row={row}
              highlight={row.user.id === meId}
              onClick={() => navigate(`/friends/${row.user.id}`)}
            />
          ))}
        </div>
      )}

      {hasMore && (
        <Button variant="ghost" className="mt-2" onClick={() => setOffset(offset + PAGE_SIZE)}>
          もっと見る
        </Button>
      )}
    </div>
  )
}

function RankingItem({
  row, highlight, onClick,
}: { row: RankingRow; highlight?: boolean; onClick: () => void }) {
  return (
    <FriendRow
      rank={row.rank}
      nickname={row.user.nickname}
      handle={row.user.handle}
      avatarUrl={row.user.avatar_url}
      power={row.value}
      highlight={highlight}
      onClick={onClick}
    />
  )
}
